import { defineComponent as _defineComponent } from 'vue'
import { AbSection, AbContainer, AbDescription, AbTitle } from '../../ui';
import UiButton from '../ui/UiButton.vue';
import { ref, computed } from 'vue-demi';
import { Spacing } from '../../../helpers/shared-props';

// TODO: fix type
interface Props {
  data: {
    title?: string;
    description?: string;
    items: any[];
    spacing?: Spacing;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSectionTabs',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    title?: string;
    description?: string;
    items: any[];
    spacing?: Spacing;
  };
};



const isShown = ref(false);
const activeVideo = ref(0);

const videos = computed(() =>
  Array.isArray(props.data) ? props.data : props.data.items
);

const show = () => {
  isShown.value = true;
};

const setActiveVideo = (index: number) => {
  isShown.value = false;
  activeVideo.value = index;
};

return { __sfc: true,props, isShown, activeVideo, videos, show, setActiveVideo, AbSection, AbContainer, AbDescription, AbTitle, UiButton }
}

})